import "./AboutUs.css";

export default function AboutUs() {
  return (
    <>
      <div id="aboutus" className="text-center text-white ourr">
        <h5 data-aos="zoom-in-right" className="heading my-5">
          About Us
        </h5>
      </div>
      <div className="container text-white ourrr ">
        <div className="row align-items-center">
          <div data-aos="flip-left" className="col-sm-4">
            <img
              style={{ Height: "200px" }}
              src="Images/single-11.jpg"
              alt="bobby"
              className="img-fluid rounded"
            />
          </div>
          <div data-aos="zoom-in-right" className="col-sm-8 px-3">
            <h5 className="small_heading">Bobby kumar</h5>
            <p className="paragraph text-center">Founder</p>
            <p className="paragraph text-center">
              My name is Bobby kumar am a Computer Science student & Computer
              enthusiast, 18 yrs old, and am GDG patna volunteer I wanna explore
              and try out my hands on everything as like Web development, App
              development, Graphic Designing and am interested in this Field.
              Student at AIMIT Patna . It is affiliated to Maulana Mazharul
              Haque Arabic and Persian University is a State University in
              Patna, Bihar, India.
            </p>
          </div>
        </div>
      </div>
    </>
  );
}
